/* eslint-disable @typescript-eslint/ban-ts-comment */
import { observer } from "mobx-react-lite";
import { FC, useEffect } from "react";
import homeStore from "../store/homeStore";
import ProductCard from "../../../components/ProductCard";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
// @ts-ignore
import "swiper/css";
// @ts-ignore
import "swiper/scss/navigation";
import { Navigation, Scrollbar, Mousewheel } from "swiper/modules";
import { isMobile } from "react-device-detect";
const PopularNow: FC = () => {
  useEffect(() => {}, []);
  return (
    <div className="flex flex-col gap-4">
      <h2 className=" text-2xl font-bold">Популярно сейчас</h2>
      <div className="w-full">
        <Swiper
          modules={[Navigation, Scrollbar, Mousewheel]} // Добавляем Mousewheel модуль
          spaceBetween={isMobile ? 5 : 20}
          className="bg-white h-full  rounded-2xl relative"
          slidesPerView={isMobile ? 2 : 5}
          // centeredSlides={isMobile}
          // slideToClickedSlide={true}
          // grabCursor={true}
          mousewheel={{
            // Активируем прокрутку колесом мыши/трекпадом
            // forceToAxis: true, // Прокрутка только по горизонтали
            // releaseOnEdges: true, // Освобождение при достижении края
            sensitivity: 1, // Чувствительность прокрутки
          }}
          scrollbar={{
            hide: false,
            draggable: true,
            snapOnRelease: true,
          }}
          freeMode={{
            // Режим свободной прокрутки
            // enabled: true,
            // momentum: true, // Инерция при прокрутке
            momentumRatio: 1,
            momentumBounce: true,
          }}
          navigation={
            !isMobile
              ? {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                  disabledClass: "swiper-button-disabled",
                }
              : false
          }
          // breakpoints={{
          //   320: {
          //     slidesPerView: 1.2,
          //     spaceBetween: 10,
          //   },
          //   480: {
          //     slidesPerView: 1.5,
          //     spaceBetween: 15,
          //   },
          //   640: {
          //     slidesPerView: 2,
          //     spaceBetween: 20,
          //   },
          //   768: {
          //     slidesPerView: 3,
          //     spaceBetween: 20,
          //   },
          //   1024: {
          //     slidesPerView: 4,
          //     spaceBetween: 20,
          //   },
          //   1280: {
          //     slidesPerView: 5,
          //     spaceBetween: 20,
          //   },
          // }}
        >
          {homeStore.popularNow.map((i) => (
            <SwiperSlide
              key={i.artikul}
              className={isMobile ? "!w-[200px]" : ""}
            >
              <ProductCard
                product={i}
                className="border-r-1 border-r-[#54545657] h-full"
              />
            </SwiperSlide>
          ))}

          {!isMobile && (
            <>
              <div className="swiper-button-prev after:text-black after:text-xl"></div>
              <div className="swiper-button-next after:text-black after:text-xl"></div>
            </>
          )}
        </Swiper>
      </div>
    </div>
  );
};

export default observer(PopularNow);
